<template>
  <div class="user">
    <center-header ref="child" active="shop" />
    <div class="">
      <!-- 搜索栏 -->
      <div class="main-flex main-flex-center seach u-centent">
        <div class="main-flex main-flex-center">
          <img src="../assets/img/logo.png">
          <div class="main-font24 margin-l-20">{{ $t('member.gwc') }}</div>
        </div>
        <div class="">
          <a-input-search
            :placeholder="$t('member.cpname')"
            :enter-button="$t('title.search')"
            style="width: 500px;"
            @search="onSearch"
          />
        </div>
      </div>
      <!-- 商品展示 -->
      <div class="u-centent">
        <div class="main-font20 u-title font-bold margin-b-20">{{ $t('member.allshop') }}{{ shopData.length }}</div>
        <div class="line" />
        <!-- 表格 -->
        <div class="u-table">
          <a-table :row-selection="rowSelection" :columns="columns" :data-source="shopData" :pagination="false" :scroll="{ x: false, y: 600 }">
            <span slot="wares" slot-scope="wares">
              <div class="t-info main-flex main-flex-center">
                <img :src="'http://' + wares[0]" style="object-fit: cover;">
                <div class="text-left">
                  <div>{{ wares[1] }}</div>
                  <div>{{ wares[2] }}-{{ wares[3] }}</div>
                </div>
              </div>
            </span>
            <span slot="parameter" slot-scope="parameter">
              <div class="text-center">
                <div style="font-size: 14px;">{{ parameter[0] }}</div>
              </div>
            </span>
            <span slot="unitprice" slot-scope="unitprice">￥{{ unitprice }}</span>
            <span slot="num" slot-scope="num, record">
              <a-input-number :min="1" :default-value="num" @change="(e)=>onNum(e,record.key)" /><span style="padding-left: 12px;">{{ $t('member.piece') }}</span>
            </span>
            <span slot="total" slot-scope="text,record">
              <div v-if="record.num>=record.discount_quantity" class="text-decoration" style="color: #999;padding-bottom: 10px;">￥{{ record.unitprice*record.num | numFilter }}</div>
              <div v-if="record.num>=record.discount_quantity">￥{{ record.unitprice*record.num*(record.discount/10) | numFilter }}</div>
              <div v-else>￥{{ record.unitprice*record.num | numFilter }}</div>
            </span>
            <template slot="action" slot-scope="text, record">
              <a-popconfirm v-if="shopData.length" :title="$t('tips.a3')" @confirm="() => onDelete([record.key])">
                <a style="color: #EA5D59;">{{ $t('member.del') }}</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
      </div>
      <!-- 结算 -->
      <div class="CheckOut">
        <div class="u-centent main-font16">
          <div class="u-left main-flex main-flex-center">
            <a-checkbox :checked="checkAll" :indeterminate="indeterminate" @change="onAllChange"> {{ $t('member.all') }}
            </a-checkbox>
            <a-popconfirm v-if="shopData.length" :title="$t('tips.a3')" @confirm="() => onDelete(selectedTableRow)">
              <a href="javascript:;" style="color: #EA5D59;margin-left: 30px;" class="main-font16">{{ $t('member.del') }}</a>
            </a-popconfirm>
          </div>
          <div class="u-right">
            {{ $t('member.ys') }}<span class="span">{{ selectedTable.length }}</span>{{ $t('member.shop') }}
            <span style="padding: 0 15px;" />
            <!-- {{ $t('title.xj') }}:<span class="span">￥{{ shopTotal|numFilter }}</span> -->
            <div class="u-btn">
              <a-button type="primary" block :disabled="!hasSelected" @click="ShowGoPay"> {{ $t('member.js') }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 结算弹窗 -->
    <a-modal v-model="pay" :closable="true" :footer="null" width="640px" :destroy-on-close="true" wrap-class-name="register">
      <div class="r_info">
        <div class="title main-font30 text-center">{{ $t('member.js') }}</div>
        <div class="info">
          <a-form :form="form" label-align="left" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" @submit="GoPay">
            <a-form-item :label="$t('member.shdz')">
              <a-select v-decorator="[ 'shipping', { rules: [{ required: true, message: $t('tips.a4') }] }, ]" :placeholder="$t('tips.a4')">
                <a-select-option v-for="(item,i) in address" :key="i" :value="i">
                  {{ item.country }}{{ item.province }}{{ item.city }}{{ item.district }}{{ item.address }}
                </a-select-option>
                <div slot="dropdownRender" slot-scope="menu">
                  <v-nodes :vnodes="menu" />
                  <a-divider style="margin: 4px 0;" />
                  <div style="padding: 4px 8px; cursor: pointer;" @mousedown="e => e.preventDefault()" @click="addItem">
                    <a-icon type="plus" /> {{ $t('member.tjdz') }}
                  </div>
                </div>
              </a-select>
            </a-form-item>
            <a-form-item>
              <span class="ant-form-text" style="font-weight: bold;"> {{ $t('title.kp') }} </span>
            </a-form-item>
            <a-form-item :label="$t('member.qymc')">
              <a-input v-decorator="[ 'company',{initialValue:member.company}, { rules: [{ required: true, message: $t('tips.s1')}] }, ]" :placeholder="$t('tips.s1')" />
            </a-form-item>
            <a-form-item :label="$t('member.ns')">
              <a-input v-decorator="[ 'taxpayer', { rules: [{ required: true, message: $t('tips.s2') }] }, ]" :placeholder="$t('tips.s2')" />
            </a-form-item>
            <a-form-item :label="$t('member.qydz')">
              <a-input v-decorator="[ 'address', { rules: [{ required: true, message: $t('tips.s3') }] }, ]" :placeholder="$t('tips.s3')" />
            </a-form-item>
            <a-form-item :label="$t('title.phone')">
              <a-input v-decorator="[ 'phone', {initialValue:member.phone},{ rules: [{ required: true, message: $t('tips.r4') }] }, ]" :placeholder="$t('tips.r4')" />
            </a-form-item>
            <a-form-item :label="$t('member.khyh')">
              <a-input v-decorator="[ 'bank', { rules: [{ required: true, message: $t('tips.s4') }] }, ]" :placeholder="$t('tips.s4')" />
            </a-form-item>
            <a-form-item :label="$t('member.yhkh')">
              <a-input v-decorator="[ 'account', { rules: [{ required: true, message: $t('tips.s5') }] }, ]" :placeholder="$t('tips.s5')" />
            </a-form-item>
            <a-form-item>
              <div class="r_btn" style="width: 514px;padding-top: 10px;">
                <a-button type="primary" html-type="submit" shape="round" block> {{ $t('member.confirm') }} </a-button>
              </div>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import CenterHeader from './common/CenterHeader'
  const columns = [{
      title: '商品信息',
      dataIndex: 'wares',
      // width: 284,
      align: 'center',
      scopedSlots: {
        customRender: 'wares'
      }
    },
    {
      title: '参数',
      dataIndex: 'parameter',
      // width: 250,
      align: 'center',
      scopedSlots: {
        customRender: 'parameter'
      }
    },
    // {
    //   title: '单价',
    //   dataIndex: 'unitprice',
    //   align: 'center',
    //   width: 196,
    //   scopedSlots: {
    //     customRender: 'unitprice'
    //   }
    // },
    {
      title: '数量',
      dataIndex: 'num',
      align: 'center',
      // width: 205,
      scopedSlots: {
        customRender: 'num'
      }
    },
    // {
    //   title: '小计',
    //   dataIndex: 'total',
    //   align: 'center',
    //   width: 196,
    //   scopedSlots: {
    //     customRender: 'total'
    //   }
    // },
    {
      title: '操作',
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      },
      align: 'center'
    }
  ];
  const shopData = [];
  export default {
    components: {
      CenterHeader,
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes
      }
    },
    filters: {
      numFilter(value) {
        let realVal = ''
        if (!isNaN(value) && value !== '') {
          // 截取当前数据到小数点后两位
          realVal = parseFloat(value).toFixed(2)
        } else {
          realVal = '--'
        }
        return realVal
      }
    },
    data() {
      return {
        shopData,
        columns,
        num: 1,
        selectedTableRow: [],
        selectedTable: [],
        shopTotal: 0,
        pay: false,
        form: this.$form.createForm(this, {
          name: 'dynamic_rule'
        }),
        address: '',
        member: ''
      }
    },
    computed: {
      hasSelected() {
        return this.selectedTableRow.length > 0;
      },
      checkAll() {
        const newData = [...this.shopData];
        return this.selectedTableRow.length == newData.length
      },
      indeterminate() {
        const newData = [...this.shopData];
        return this.selectedTableRow.length > 0 && this.selectedTableRow.length < newData.length
      },
      rowSelection() {
        return {
          onChange: (selectedRowKeys, selectedRows) => {
            this.selectedTableRow = selectedRowKeys
            this.selectedTable = selectedRows
            // console.log(this.selectedTable)
            var sum = 0
            for (var i = 0; i < this.selectedTable.length; i++) {
              var a = 0;
              if (this.selectedTable[i].num < this.selectedTable[i].discount_quantity) {
                a = this.selectedTable[i].num * this.selectedTable[i].unitprice
              } else {
                a = this.selectedTable[i].num * this.selectedTable[i].unitprice * (this.selectedTable[i].discount /
                  10)
              }
              sum = sum + a
            }
            this.shopTotal = sum
          },
          selectedRowKeys: this.selectedTableRow,
          getCheckboxProps: record => ({
            props: {
              disabled: record.name === 'Disabled User', // Column configuration not to be checked
              name: record.name
            }
          })
        };
      }
    },
    watch: {
      '$route': {
        handler(route) {
          const that = this
          if (route.name === '/shoppingcar') {
            that.init(that.$store.state.langStates, '')
          }
        }
      },
      '$store.state.langStates': function(val) {
        this.init(val, '')
      }
    },
    created() {
      this.init(this.$store.state.langStates, '')
    },
    mounted() {
      this.getMember()
    },
    methods: {
      getMember() {
        let userMember;
        setTimeout(() => {
          userMember = this.$refs.child.userMember;
          if (userMember) {
            this.member = this.$refs.child.userMember;
          } else {
            this.getMember()
          }
        }, 30)
      },
      init(lang, name) {
        this.shopData = []
        // 购物车列表
        this.$api.dongjuapi.get_carts({
          lang,
          name: name
        }).then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            this.shopData.push({
              key: res.data.data[i].specification_id,
              wares: [res.data.data[i].image_head_file, res.data.data[i].category, res.data.data[i].series, res
                .data.data[i].name
              ],
              parameter: [res.data.data[i].models],
              unitprice: res.data.data[i].unit_price,
              num: res.data.data[i].amount,
              discount: res.data.data[i].discount,
              discount_quantity: res.data.data[i].discount_quantity
            })
          }
        })
        // 收货地址
        this.$api.dongjuapi.addressList().then(res => {
          this.address = res.data.data
        }).catch(err => {
          this.$message.error(err.data.message);
        })
      },
      ShowGoPay() {
        this.pay = true
        console.log(this.member)
      },
      GoPay(e) {
        e.preventDefault();
        this.form.validateFields((err, values) => {
          if (!err) {
            console.info('success', values);
            const address_id = this.address[values.shipping].id
            const items = []
            for (var i = 0; i < this.selectedTable.length; i++) {
              items.push({
                specification_id: this.selectedTable[i].key,
                amount: this.selectedTable[i].num
              })
            }
            const invoice = {
              company: values.company,
              taxpayer: values.taxpayer,
              address: values.address,
              phone: values.phone,
              bank: values.bank,
              account: values.account
            }
            const params = {
              address_id: address_id,
              items,
              invoice
            }
            this.$api.dongjuapi.get_order(params).then(res => {
              if (res.data.code == 200) {
                this.$router.push({
                  path: '/settlement?no=' + res.data.data.no + '&price=' + res.data.data.total_amount
                })
              }
            })
          }
        });
      },
      addItem() {
        this.$router.push({
          path: '/address'
        })
      },
      onSearch(value) {
        this.init(this.$store.state.langStates, value)
      },
      onNum(value, key) {
        const newData = [...this.shopData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.num = value
          this.shopData = newData
        }
        var sum = 0
        for (var i = 0; i < this.selectedTable.length; i++) {
          var a = 0
          if (this.selectedTable[i].num < this.selectedTable[i].discount_quantity) {
            a = this.selectedTable[i].num * this.selectedTable[i].unitprice
          } else {
            a = this.selectedTable[i].num * this.selectedTable[i].unitprice * (this.selectedTable[i].discount / 10)
          }
          sum = sum + a
          // console.log(a,sum)
        }
        this.shopTotal = sum
      },
      onDelete(key) {
        this.$api.dongjuapi.delete_carts({
          specification_ids: key
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.data);
            this.init(this.$store.state.langStates, '')
          }
        })
      },
      onAllChange() {
        const newData = [...this.shopData];
        if (this.selectedTableRow.length == newData.length) {
          this.selectedTableRow = []
          this.selectedTable = []
          this.ckAll = false
        } else if (this.selectedTableRow.length > 0 && this.selectedTableRow.length < newData.length) {
          this.selectedTableRow = []
          this.selectedTable = []
          for (var i = 0; i < newData.length; i++) {
            this.selectedTableRow.push(newData[i].key)
            this.selectedTable.push(newData[i])
          }
        } else {
          for (var i = 0; i < newData.length; i++) {
            this.selectedTableRow.push(newData[i].key)
            this.selectedTable.push(newData[i])
          }
        }
        var sum = 0
        for (var i = 0; i < this.selectedTable.length; i++) {
          var a = 0
          if (this.selectedTable[i].num < this.selectedTable[i].discount_quantity) {
            a = this.selectedTable[i].num * this.selectedTable[i].unitprice
          } else {
            a = this.selectedTable[i].num * this.selectedTable[i].unitprice * (this.selectedTable[i].discount / 10)
          }
          // console.log(a,sum)
          sum = sum + a
        }
        this.shopTotal = sum
      }
    }
  }
</script>

<style lang="less">
  .user {
    width: 100%;
    height: auto;
    background: #fff;
    padding-bottom: 80px;

    .seach {
      height: 190px;
      justify-content: space-between;
      padding: 50px 0 60px 0;

      img {
        width: auto;
        height: 40px;
      }
    }

    .u-title {
      color: #1F5EA5;
      line-height: 30px;
      letter-spacing: 2px;
    }

    .line {
      width: 100%;
      height: 4px;
      background: #1F5EA5;
    }
  }

  .u-table {
    width: 100%;
    margin-top: 50px;
    margin-bottom: 60px;
    border: 1px solid #eee;

    .t-info {
      padding: 4px 29px;

      img {
        width: 80px;
        height: 80px;
        border: 1px solid rgba(187, 187, 187, 1);
        margin-right: 12px;
      }
    }
  }

  .CheckOut {
    width: 100%;
    height: 80px;
    background: #E1E1E1;

    >div {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .u-left {
      .ant-checkbox-wrapper {
        display: flex;
        align-items: center;
      }

      .ant-checkbox+span {
        padding: 0;
        padding-left: 6px;
        font-size: 20px;
      }
    }

    .u-right {
      display: flex;
      align-items: center;

      .u-btn {
        width: 120px;
        margin-left: 30px;

        .ant-btn {
          height: 50px;
        }
      }

      .span {
        color: #1F5EA5;
        font-weight: bold;
        font-size: 20px;
        padding: 0 5px;
      }
    }
  }
</style>
